// API Configuration
// This file centralizes all API endpoint URLs

let API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
// Remove trailing slash if present to avoid double-slash issues in endpoints
API_BASE_URL = API_BASE_URL.replace(/\/$/, '');

export const API_ENDPOINTS = {
    // Authentication
    LOGIN: `${API_BASE_URL}/api/login`,
    REQUEST_OTP: `${API_BASE_URL}/api/login/request-otp`,
    VERIFY_OTP: `${API_BASE_URL}/api/login/verify-otp`,
    SIGNUP: `${API_BASE_URL}/api/signup`,
    FORGOT_PASSWORD: `${API_BASE_URL}/api/forgot-password`,
    VERIFY_TOKEN: `${API_BASE_URL}/api/verify-token`,
    RESET_PASSWORD: `${API_BASE_URL}/api/reset-password`,
    GOOGLE_AUTH: `${API_BASE_URL}/api/google-auth`,

    // AI Chat
    ASK: `${API_BASE_URL}/api/ask`,
    HISTORY: `${API_BASE_URL}/api/history`,
    MARK_WELCOME_SEEN: `${API_BASE_URL}/api/welcome/mark_seen`,

    // Audio (if needed)
    SPEAK:         `${API_BASE_URL}/api/speak`,
    SPEAK_STREAM:  `${API_BASE_URL}/api/speak-stream`,
    TRANSCRIBE:    `${API_BASE_URL}/api/transcribe`,

    // Admin
    ADMIN_METRICS: `${API_BASE_URL}/api/admin/metrics`,
    CREATE_ADMIN: `${API_BASE_URL}/api/admin/create-admin`,
    GRANT_ACCESS: `${API_BASE_URL}/api/admin/grant-access`,
    ADMIN_COUPONS: `${API_BASE_URL}/api/admin/coupons`,

    // User stats & limits
    USER_STATS: `${API_BASE_URL}/api/user/stats`,
    CHAT_LIMIT: `${API_BASE_URL}/api/user/chat-limit`,

    // Checkout
    VALIDATE_COUPON: `${API_BASE_URL}/api/coupons/validate`,
    LIST_COUPONS: `${API_BASE_URL}/api/coupons/list`,
    
    // Payments
    CREATE_ORDER: `${API_BASE_URL}/api/payments/create-order`,
    VERIFY_PAYMENT: `${API_BASE_URL}/api/payments/verify`,
    CLAIM_FREE: `${API_BASE_URL}/api/payments/claim-free`,
    VERIFY_SUBSCRIPTION: `${API_BASE_URL}/api/payments/verify-subscription`,
    CANCEL_SUBSCRIPTION: `${API_BASE_URL}/api/payments/cancel-subscription`,
};

export const GOOGLE_CLIENT_ID = '895114097307-l3e958dkadv96kkdt6ihs8rb27r9rtu8.apps.googleusercontent.com';

export default API_BASE_URL;
